<script>
import state from '../states'
let {chart} = state
</script>
<div class="absolute sticky bg-gray-900 text-white w-screen h-12">
  <div ><img src="logo-192.png" alt="logo" class="h-12" on:click={()=>{chart.set()}}/></div>
</div>